module.exports = __webpack_public_path__ + "static/media/Drive Safety.e4f4548d.png";